<template>
  <div id="app">
    <router-view />
     <!-- 全局音效 -->
    <audio src id="eventAudio" loop></audio>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="less">
@import "./assets/css/reset.css";
@import "./assets/css/base.less";
#app {
  font-family: "Microsoft Yahei", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background: white;
 background-size: 100% 100%;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.24rem;
  span {
    margin-left: 2%;
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue